import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Interactions } from '@chegg/pricing-sdk';
import { getVCookie } from '@chegg/utils';
var HOME_PAGE_RELATIVE_URL = '/';
/**
 * Returns {@link getNextInteractionPayload} from pricing-sdk {@link pricingApi} result
 */
var getNextInteractionPayload = function getNextInteractionPayload(_ref) {
  var _getVCookie;
  var errorUrl = _ref.errorUrl,
    hostAnnotations = _ref.hostAnnotations,
    _ref$interactions = _ref.interactions,
    interactions = _ref$interactions === void 0 ? [Interactions.DCO_1_CLICK, Interactions.OTHER, Interactions.DCO_1_CLICK_NO_PRIOR_ORDER] : _ref$interactions,
    _ref$itemAnnotations = _ref.itemAnnotations,
    itemAnnotations = _ref$itemAnnotations === void 0 ? {} : _ref$itemAnnotations,
    pricingData = _ref.pricingData,
    productName = _ref.productName,
    successUrl = _ref.successUrl;
  return {
    interactions: interactions,
    pricingData: pricingData,
    productName: productName,
    itemAnnotations: itemAnnotations,
    successUrl: successUrl !== null && successUrl !== void 0 ? successUrl : HOME_PAGE_RELATIVE_URL,
    errorUrl: errorUrl !== null && errorUrl !== void 0 ? errorUrl : HOME_PAGE_RELATIVE_URL,
    hostAnnotations: _objectSpread(_objectSpread({}, hostAnnotations), {}, {
      uvn: (_getVCookie = getVCookie()) !== null && _getVCookie !== void 0 ? _getVCookie : ''
    })
  };
};
export default getNextInteractionPayload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getNextInteractionPayload.js
// module id = 1400
// module chunks = 11